import React, { useState, useEffect } from "react";
import ColorFieldComponent from "../../../Components/Forms/ColorFieldComponent";
import ImageUploadComponent from "../../../Components/Forms/ImageUploadComponent";
import { ConeConfiguracao } from "../../../Models/Paineis/ConeDeRisco/ConeConfiguracao";
import { ReactComponent as ConeTopoEmViagem } from "../../../Svgs/topo_em_viagem.svg";
import { ReactComponent as ConeTopoFinalizadas } from "../../../Svgs/topo_finalizadas.svg";
import { ReactComponent as ConeTopoProgramadas } from "../../../Svgs/topo_programadas.svg";

const ConeConfiguracaoFundoTab = (props: any) => {
    const [coneConfiguracao, setConeConfiguracao] = useState<any>(new ConeConfiguracao());

    useEffect(() => {
        setConeConfiguracao(props.coneConfiguracao);
    }, [props.coneConfiguracao]);

    return (
        <div>
            <div className="row">
                <div className="col-md-2 mb-2">
                    <ImageUploadComponent
                        label="Logotipo"
                        field='logotipo'
                        uploadedField='file_to_upload'
                        default='KronaMaxxiReduzida.png'
                        model={coneConfiguracao}
                    />
                </div>
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Fundo"
                        field='cor_fundo'
                        type='background-color'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={coneConfiguracao}
                    />
                </div>
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor cabeçalho"
                        field='cor_cabecalho'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={coneConfiguracao}
                    />
                </div>
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Fonte Cabeçalho"
                        field='cor_fonte_cabecalho'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={coneConfiguracao}
                    />
                </div>
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Fonte Título"
                        field='cor_fonte_titulo'
                        type='color'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={coneConfiguracao}
                    />
                </div>
            </div>

            <div className="row area_cor_fundo">
                <div className="col-md-4 mb-4">
                    <ConeTopoProgramadas />
                </div>
                <div className="col-md-4 mb-4">
                    <ConeTopoEmViagem />
                </div>
                <div className="col-md-4 mb-4">
                    <ConeTopoFinalizadas />
                </div>

                <h4 className="col-md-12"><strong className="chart-title area_cor_fonte_titulo">RASTREAMENTO E GERENCIAMENTO DE RISCO</strong></h4>
            </div>
        </div>
    );
}

export default ConeConfiguracaoFundoTab;